import { useState } from "react";
import PayementTotalChargeChequeFN from "./PayementMethods/PayementTotalChargeChequeFN";
import PayementTotalChargeEnLigneFN from "./PayementMethods/PayementTotalChargeEnLigneFN";
import PayementTotalChargeEspeceFN from "./PayementMethods/PayementTotalChargeEspeceFN";
import PayementTotalChargeVirementFN from "./PayementMethods/PayementTotalChargeVirementFN";
import PayementTotalChargePrelevementFN from "./PayementMethods/PayementTotalChargePrelevementFN";

const MethodePayementChargeTotal = () => {
  const [methodePayement, setMethodePayement] = useState("");

  const createUIPayement = () => {
    if (methodePayement === "CHEQUE") {
        return <PayementTotalChargeChequeFN />;
    } else if (methodePayement === "ENLIGNE") {
        return <PayementTotalChargeEnLigneFN />;
    } else if (methodePayement === "ESPECE") {
        return <PayementTotalChargeEspeceFN/>;
    } else if (methodePayement === "VIREMENT") {
        return <PayementTotalChargeVirementFN />;
    } else if (methodePayement === "PRELEVEMENT") {
        return <PayementTotalChargePrelevementFN />;
    }
  };
  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setMethodePayement(payement);
  };
  const listOptionsPayement = () => {
    if (localStorage.getItem("status").includes("ADMIN")) {

    return (
      <select class="form-control" onChange={handleChangePayement}>
        <option key={0} value={0}>
          Sélectionner un mode de payement
        </option>
        <option key={1} value={"ESPECE"}>
          Espèce
        </option>
        <option key={2} value={"ENLIGNE"}>
          En ligne
        </option>
        <option key={3} value={"CHEQUE"}>
          Chèques / Traites
        </option>
        <option key={4} value={"VIREMENT"}>
          Virement
        </option>
        <option key={6} value={"PRELEVEMENT"}>
          Prélèvement
        </option>
      </select>
    );
  }else if(localStorage.getItem("status").includes("DIRECTEUR_MAGASIN")){
      return (
      <select class="form-control" onChange={handleChangePayement}>
        <option key={0} value={0}>
          Sélectionner un mode de payement
        </option>
        <option key={1} value={"ESPECE"}>
          Espèce
        </option>
      </select>
    );
  }
  };
  return (
    <div className="card-body">
      <h5 className="card-title">Choisir le mode de payement </h5>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-10">{listOptionsPayement()}</div>
      </div>

      {createUIPayement()}
      <br />
    </div>
  );
};
export default MethodePayementChargeTotal;
